import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class PbSnapImageService {

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  formDataHttpOptions = {
    headers:new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  constructor(private http: HttpClient, private constant: Constant) {

  }

  getAll(eventProjectId?: number, page: number = 1, perPage: number = 10): Observable<any> {
    let params = `?page=${page}&per_page=${perPage}`;
    if (eventProjectId) { params += `&event_project_id=${eventProjectId}`; }
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/pb-snap-image' + params, this.httpOptions);
  }

  delete(id): Observable<any> {
    return this.http.delete<any>(this.constant.API_DOMAIN + "/api/v1/pb-snap-image/"+id, this.httpOptions);
  }

  zipDownload(ids: string[]): Observable<Blob> {
    return this.http.post(
      this.constant.API_DOMAIN + '/api/v1/pb-snap-image/zip-download',
      { ids },
      { ...this.httpOptions, responseType: 'blob' }
    );
  }

  getFileAsBlob(url: string): Observable<Blob> {
    return this.http.get(url, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('access_token') }),
      responseType: 'blob'
    });
  }

  // Error handling
  handleError(e) {
  console.log(e);
  if(e.error && e.error.message) {
    return throwError(e.error.message);
  }
  return throwError('');
  }
}